import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './NewsTicker.css';

const NewsTicker = () => {
  const { isMarathi } = useLanguage();

  const newsItems = isMarathi() ? [
    {
      text: "१) महाराष्ट्राने नवीन 'औद्योगिक संबंध संहिते'अंतर्गत राज्य नियमावली अधिसूचित केली आहे. तुमचा अभिप्राय महत्त्वाचा आहे - तुमच्या सूचना १२.०६.२०२६ पर्यंत सादर करा.",
      link: "https://mlwb.in//react-static-files/pdf/tenders-and-notices/2026/04/1_Code_on_IR_Draft_Rules_2026.pdf"
    },
    {
      text: "२) महाराष्ट्राने नवीन 'वेतन संहिते'अंतर्गत राज्य नियम अधिसूचित केले आहेत. तुमचा अभिप्राय महत्त्वाचा आहे – तुमच्या सूचना १२.०६.२०२६ पर्यंत सादर करा.",
      link: "https://mlwb.in//react-static-files/pdf/tenders-and-notices/2026/04/2_Code_on_Wages_Draft_Rules_2026_Published.pdf"
    }
  ] : [
    {
      text: "1) Maharashtra notified State Rules under the New Industrial Relations Code. Your feedback matters - submit your suggestions by 12.06.2026",
      link: "https://mlwb.in//react-static-files/pdf/tenders-and-notices/2026/04/1_Code_on_IR_Draft_Rules_2026.pdf"
    },
    {
      text: "2) Maharashtra notified State Rules under the New Wages Code. Your feedback matters - submit your suggestions by 12.06.2026",
      link: "https://mlwb.in//react-static-files/pdf/tenders-and-notices/2026/04/2_Code_on_Wages_Draft_Rules_2026_Published.pdf"
    }
  ];

  const handleNewsItemClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <div className="news-ticker" id="news-ticker" data-read-section="whats-new">
      <div className="news-ticker-container">
        <div className="news-content">
          <div className="news-label">
            <svg className="news-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/>
              <path d="M18 14h-8"/>
              <path d="M15 18h-5"/>
              <path d="M10 6h8v4h-8V6Z"/>
            </svg>
            {isMarathi() ? 'नवीन काय आहे' : 'What\'s New'}
          </div>
          <div className="news-scroll">
            <div className="news-items">
              {newsItems.map((item, index) => (
                <React.Fragment key={index}>
                  <span className="news-item" onClick={() => handleNewsItemClick(item.link)}>
                    {item.text}
                  </span>
                  <span className="news-separator"> | </span>
                </React.Fragment>
              ))}
              {/* Duplicate items for seamless loop */}
              {newsItems.map((item, index) => (
                <React.Fragment key={`duplicate-${index}`}>
                  <span className="news-item" onClick={() => handleNewsItemClick(item.link)}>
                    {item.text}
                  </span>
                  <span className="news-separator"> | </span>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
